import { Button, Image, Text } from "components/commons";
import { dateFormat, dateTimeFormatV2, formatAmount, timeFormat } from "utils";
import styles from "./bank-deposit-list.module.scss";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { ViewAttachment } from "images";

export const mapDataToList = ({ bankDeposits, onClickViewSlip, onClickView }) => {
  const { bankDepositId, depositedAt, shift, amount, type, imageUrl } = bankDeposits;

  const shiftDate = shift ? (
    <>
      <Text className={styles.td}>
        {shift?.startShift
          ? dateTimeFormatV2(shift?.startShift) + (shift?.endShift ? " - " : "")
          : ""}
      </Text>
      <Text className={styles.td}>{shift?.endShift ? dateTimeFormatV2(shift?.endShift) : ""}</Text>
    </>
  ) : (
    "--"
  );

  return {
    bankDepositId: (
      <>
        <Text className={styles.td}>{bankDepositId ?? ""}</Text>
      </>
    ),
    depositedAt: (
      <>
        <Text className={styles.td}>{dateFormat(depositedAt ?? "")}</Text>
        <Text className={styles.td}>{timeFormat(depositedAt ?? "")}</Text>
      </>
    ),
    shiftDate: shiftDate,
    amount: (
      <>
        <Text className={styles.td}>{formatAmount(amount) ?? ""}</Text>
      </>
    ),
    type: (
      <>
        <Text className={styles.td}>{type ?? ""}</Text>
      </>
    ),
    viewAttachment: (
      <Button
        style={{ textDecoration: "none", background: !imageUrl ? "none" : undefined }}
        link
        onClick={() => onClickViewSlip(imageUrl)}
        disabled={!imageUrl}
      >
        <Image src={ViewAttachment} className={imageUrl ? styles.iconCustom : ""} />
      </Button>
    ),
    actions: (
      <Button style={{ textDecoration: "none" }} link onClick={() => onClickView?.(bankDepositId)}>
        <div
          style={{
            color: "#5349b7",
            fontWeight: "500",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <span>View</span>
          <NavigateNextIcon fontSize="small" />
        </div>
      </Button>
    ),
  };
};

export const mapFilterToRequest = (filterState) => {
  const { type, ...fs } = filterState;

  return {
    ...fs,
    type: !type.isSelectedAll ? type.value.join(",") : undefined,
  };
};
